import React from "react";
import Search from "../../Search";

const Popular = () => {
  return (
    <div>
      <div className="pt-10 flex justify-end pr-6">
        
      </div>
    </div>
  );
};

export default Popular;
